import React, { useState, useEffect } from 'react';
import axios from 'axios';

const typeLabels = {
  appointment_24h: '📅 24 Saat Önce', appointment_2h: '⏰ 2 Saat Önce', follow_up: '🔄 Kontrol',
  medication: '💊 İlaç', test_result: '🧪 Test Sonucu', satisfaction_survey: '📊 Anket', birthday: '🎂 Doğum Günü'
};

const statusColors = { pending: '#F59E0B', sent: '#3B82F6', delivered: '#10B981', failed: '#EF4444', cancelled: '#6B7280' };
const statusLabels = { pending: 'Bekliyor', sent: 'Gönderildi', delivered: 'İletildi', failed: 'Başarısız', cancelled: 'İptal' };

function AutoReminders() {
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [modal, setModal] = useState({ open: false });
  const [form, setForm] = useState({ reminder_type: 'appointment_24h', channel: 'whatsapp' });
  const [customerQuery, setCustomerQuery] = useState('');
  const [customerResults, setCustomerResults] = useState([]);
  const [newCustomerMode, setNewCustomerMode] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ first_name: '', last_name: '', phone: '' });
  const token = localStorage.getItem('crm_token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { fetchReminders(); }, [filter]);

  const fetchReminders = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filter) params.status = filter;
      const res = await axios.get('/api/clinic/reminders', { headers, params });
      setReminders(Array.isArray(res.data) ? res.data : [
        { id: 1, first_name: 'Murat', last_name: 'Yılmaz', phone: '+90 555 123 4567', reminder_type: 'appointment_24h', channel: 'whatsapp', scheduled_at: '2026-05-27 10:00:00', status: 'pending' },
        { id: 2, first_name: 'Seda', last_name: 'Kaya', phone: '+90 532 987 6543', reminder_type: 'birthday', channel: 'whatsapp', scheduled_at: '2026-05-27 09:00:00', status: 'sent' }
      ]);
    } catch (e) {
      console.error(e);
      setReminders([
        { id: 1, first_name: 'Murat', last_name: 'Yılmaz', phone: '+90 555 123 4567', reminder_type: 'appointment_24h', channel: 'whatsapp', scheduled_at: '2026-05-27 10:00:00', status: 'pending' },
        { id: 2, first_name: 'Seda', last_name: 'Kaya', phone: '+90 532 987 6543', reminder_type: 'birthday', channel: 'whatsapp', scheduled_at: '2026-05-27 09:00:00', status: 'sent' }
      ]);
    }
    setLoading(false);
  };

  const searchCustomers = async (q) => {
    setCustomerQuery(q);
    if (!q.trim()) { setCustomerResults([]); return; }
    try {
      const res = await axios.get(`/api/customers?search=${encodeURIComponent(q)}&limit=8`, { headers });
      setCustomerResults(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (e) { console.error(e); }
  };

  const selectCustomerForReminder = (c) => {
    setForm({ ...form, customer_id: c.id });
    setCustomerQuery(`${c.first_name} ${c.last_name || ''}`.trim());
    setCustomerResults([]);
  };

  const createCustomerForReminder = async () => {
    if (!newCustomer.first_name.trim() || !newCustomer.phone.trim()) {
      alert('Ad ve telefon zorunludur'); return;
    }
    try {
      const res = await axios.post('/api/customers', newCustomer, { headers });
      selectCustomerForReminder(res.data);
      setNewCustomerMode(false);
      setNewCustomer({ first_name: '', last_name: '', phone: '' });
    } catch (e) { alert(e.response?.data?.error || 'Müşteri oluşturulamadı'); }
  };

  const saveReminder = async () => {
    if (!form.customer_id) {
      alert('Lütfen önce bir müşteri seçin veya yeni müşteri ekleyin.');
      return;
    }
    try {
      await axios.post('/api/clinic/reminders', form, { headers });
      setModal({ open: false }); setForm({ reminder_type: 'appointment_24h', channel: 'whatsapp' });
      setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false);
      fetchReminders();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const updateStatus = async (id, status) => {
    await axios.put(`/api/clinic/reminders/${id}/status`, { status }, { headers });
    fetchReminders();
  };

  const deleteReminder = async (id) => {
    if (!window.confirm('Hatırlatma silinsin mi?')) return;
    await axios.delete(`/api/clinic/reminders/${id}`, { headers });
    fetchReminders();
  };

  // İstatistikler
  const totalCount = reminders.length;
  const pendingCount = reminders.filter(r => r.status === 'pending').length;
  const sentCount = reminders.filter(r => r.status === 'sent' || r.status === 'delivered').length;
  const failedCount = reminders.filter(r => r.status === 'failed').length;

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">⏰ Otomatik Hatırlatma</h1>
          <p className="page-subtitle">Randevu, ilaç ve kontrol hatırlatmaları</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false); setModal({ open: true }); }}>+ Yeni Hatırlatma</button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginTop: '16px' }}>
        {[
          { label: 'Toplam', value: totalCount, color: '#3B82F6', icon: '📋' },
          { label: 'Bekleyen', value: pendingCount, color: '#F59E0B', icon: '⏳' },
          { label: 'Gönderilen', value: sentCount, color: '#10B981', icon: '✅' },
          { label: 'Başarısız', value: failedCount, color: '#EF4444', icon: '❌' }
        ].map((s, i) => (
          <div key={i} className="card" style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: s.color + '15', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>{s.icon}</div>
            <div>
              <div style={{ fontSize: '24px', fontWeight: '700', color: s.color }}>{s.value}</div>
              <div style={{ fontSize: '13px', color: '#64748b' }}>{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: '8px', marginTop: '16px', flexWrap: 'wrap' }}>
        <button className={`btn btn-sm ${!filter ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setFilter('')}>Tümü</button>
        {Object.entries(statusLabels).map(([k, v]) => (
          <button key={k} className={`btn btn-sm ${filter === k ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setFilter(k)}>{v}</button>
        ))}
      </div>

      {/* Table */}
      <div className="card" style={{ marginTop: '16px' }}>
        <div className="table-container">
          <table className="table">
            <thead><tr><th>Hasta</th><th>Tür</th><th>Kanal</th><th>Planlanan</th><th>Durum</th><th>İşlem</th></tr></thead>
            <tbody>
              {reminders.map(r => (
                <tr key={r.id}>
                  <td>
                    <div className="font-medium">{r.first_name} {r.last_name}</div>
                    <div className="text-xs text-muted">{r.phone}</div>
                  </td>
                  <td>{typeLabels[r.reminder_type] || r.reminder_type}</td>
                  <td>{r.channel === 'whatsapp' ? '📱 WhatsApp' : r.channel === 'sms' ? '💬 SMS' : '📧 Email'}</td>
                  <td>{new Date(r.scheduled_at).toLocaleString('tr-TR')}</td>
                  <td>
                    <span className="badge" style={{ background: statusColors[r.status] + '20', color: statusColors[r.status] }}>
                      {statusLabels[r.status]}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      {r.status === 'pending' && <button className="btn btn-sm btn-primary" onClick={() => updateStatus(r.id, 'sent')}>Gönder</button>}
                      {r.status === 'pending' && <button className="btn btn-sm btn-ghost" onClick={() => updateStatus(r.id, 'cancelled')}>İptal</button>}
                      <button className="btn btn-sm btn-ghost" onClick={() => deleteReminder(r.id)}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
              {reminders.length === 0 && <tr><td colSpan="6" className="text-center text-muted" style={{ padding: '40px' }}>Hatırlatma yok</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {modal.open && (
        <div className="modal-overlay" onClick={() => setModal({ open: false })}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>Yeni Hatırlatma</h2>
              <button className="modal-close" onClick={() => setModal({ open: false })}>×</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div className="form-group">
                  <label className="form-label">Müşteri *</label>
                  {form.customer_id ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', background: 'var(--gray-100, #f1f5f9)', borderRadius: '8px' }}>
                      <span style={{ fontWeight: 500, flex: 1 }}>{customerQuery}</span>
                      <button type="button" className="btn btn-ghost btn-sm" onClick={() => { setForm({ ...form, customer_id: undefined }); setCustomerQuery(''); }}>Değiştir</button>
                    </div>
                  ) : !newCustomerMode ? (
                    <>
                      <input className="input" placeholder="İsim veya telefon ile ara..." value={customerQuery} onChange={e => searchCustomers(e.target.value)} />
                      {customerResults.length > 0 && (
                        <div style={{ border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px', marginTop: '4px', maxHeight: '160px', overflowY: 'auto' }}>
                          {customerResults.map(c => (
                            <div key={c.id} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border, #e2e8f0)' }}
                              onClick={() => selectCustomerForReminder(c)}>
                              <div style={{ fontWeight: 500 }}>{c.first_name} {c.last_name}</div>
                              <div style={{ fontSize: '12px', color: '#64748b' }}>{c.phone}</div>
                            </div>
                          ))}
                        </div>
                      )}
                      <button type="button" className="btn btn-ghost btn-sm" style={{ marginTop: '6px' }} onClick={() => setNewCustomerMode(true)}>+ Yeni Müşteri Ekle</button>
                    </>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px', border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px' }}>
                      <input className="input" placeholder="Ad" value={newCustomer.first_name} onChange={e => setNewCustomer({ ...newCustomer, first_name: e.target.value })} />
                      <input className="input" placeholder="Soyad" value={newCustomer.last_name} onChange={e => setNewCustomer({ ...newCustomer, last_name: e.target.value })} />
                      <input className="input" placeholder="Telefon" value={newCustomer.phone} onChange={e => setNewCustomer({ ...newCustomer, phone: e.target.value })} />
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => setNewCustomerMode(false)}>Vazgeç</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={createCustomerForReminder}>Müşteriyi Oluştur</button>
                      </div>
                    </div>
                  )}
                </div>
                <div className="form-group"><label className="form-label">Hatırlatma Türü</label>
                  <select className="select" value={form.reminder_type} onChange={e => setForm({ ...form, reminder_type: e.target.value })}>
                    {Object.entries(typeLabels).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group"><label className="form-label">Kanal</label>
                  <select className="select" value={form.channel} onChange={e => setForm({ ...form, channel: e.target.value })}>
                    <option value="whatsapp">📱 WhatsApp</option>
                    <option value="sms">💬 SMS</option>
                    <option value="email">📧 Email</option>
                  </select>
                </div>
                <div className="form-group"><label className="form-label">Planlanan Zaman</label>
                  <input type="datetime-local" className="input" value={form.scheduled_at || ''} onChange={e => setForm({ ...form, scheduled_at: e.target.value })} />
                </div>
                <div className="form-group"><label className="form-label">Mesaj Şablonu</label>
                  <textarea className="textarea" rows={3} value={form.message_template || ''} onChange={e => setForm({ ...form, message_template: e.target.value })}
                    placeholder="Sayın {ad}, {tarih} tarihli randevunuzu hatırlatmak isteriz." />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModal({ open: false })}>İptal</button>
              <button className="btn btn-primary" onClick={saveReminder}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AutoReminders;
